 /**
  * Autocomplete
  *
  *
  */

import React from 'react/addons';
import fuzzy from 'fuzzy';
import UniqueId from 'utils/unique-id';
import ClassNames from 'classnames';
import KeyCode from 'utils/key-code';
import Paper from 'components/paper/Paper';
import Selector from './Selector';
import CloseIcon from 'components/svg-icons/close';
import DropDownIcon from 'components/svg-icons/drop-down-arrow';
import Transition from 'components/transition-groups/Transition';
import ClickAway from 'mixins/js/ClickAway';
import EnhancedTextarea from 'components/forms/enhanced-textarea/EnhancedTextarea';
import TextField from 'components/forms/text-field/TextField';

const PureRenderMixin = React.addons.PureRenderMixin;

export default React.createClass({

	displayName: 'Autocomplete',

	mixins: [ ClickAway, PureRenderMixin ],

	manuallyBindClickAway: true,

	propTypes: {
		options: React.PropTypes.array.isRequired, 		// Options that are passed to Autocomplete
		hintText: React.PropTypes.string.isRequired, 	// aka placeholder (not sure which prop name were gonna end up using)
		disabled: React.PropTypes.bool, 				// ***TO DO get this working***
		maxVisible: React.PropTypes.number, 			// do we even want this??? we have a fixed max-height in css that a user can theme-ably overwrite
		onOptionSelected: React.PropTypes.func, 		// event triggered when an option is selected
		onDismiss: React.PropTypes.func, 				// on escape/dismiss event
		onKeyDown: React.PropTypes.func, 				// on key down event
		onChange: React.PropTypes.func, 				// on change event
		defaultLabel: React.PropTypes.string, 			// default entry label of the input
		defaultValue: React.PropTypes.string, 			// default entry value -- will fill in the value of the input as well using the label
		depth: React.PropTypes.number, 					// paper depth options
		rounded: React.PropTypes.bool, 					// rounded corners
		status: React.PropTypes.string,					// primary,success,alert, etc...
		subtext: React.PropTypes.string, 				// the bottom right hand corner text
		optionValidate: React.PropTypes.bool, 			// when this is true, a user MUST pick an option
		isSelect: React.PropTypes.bool,  				// turns the autocomplete in to a generic dropdown selector
		floatingLabelText: React.PropTypes.string,		// adds a floating text label much like TextField
		underlinePosition: React.PropTypes.oneOf(['top','bottom','none']),	// determines the position of the underline/overline
		selectorPosition: React.PropTypes.oneOf(['top','bottom']),			// determines the position of the dropdown selector

	},

	getDefaultProps() {
		return {
			options: [],
			underlinePosition: 'top',
			selectorPosition: 'bottom',
			customClasses: {},
			defaultLabel: "",
			disabled: false,
			hintText: "",
			depth: 1,
			rounded: true,
			status: "primary",
			subtext: '',
			optionValidate: false,
			isSelect: false,
			onDismiss: function() {},
			onKeyDown: function(event) {
				return
			},
			onOptionSelected: function(option) {}
		};
	},

	getInitialState() {
		return {
			visible: this.getOptionsFilter(this.props.entryValue, this.props.options),
			entryValue: this.props.defaultLabel ? 
				this.props.defaultLabel : this.props.defaultValue ? 
				this.getOptionsFilter(this.props.defaultValue, this.props.options, true)[0].label : '',
			selection: this.props.defaultLabel ? 
				this.getOptionsFilter(this.props.defaultLabel, this.props.options)[0] : this.props.defaultValue ?
				this.getOptionsFilter(this.props.defaultValue, this.props.options, true)[0] : null,
			open: false,
			hintText: this.props.hintText,
			focus: false,
			status: this.props.status,
			subtext: this.props.subtext,
			selectedValue: this.props.defaultLabel ? 
				this.getOptionsFilter(this.props.defaultLabel, this.props.options)[0] : this.props.defaultValue ?
				this.getOptionsFilter(this.props.defaultValue, this.props.options, true)[0] : null,
		}
	},

	componentDidMount() {
		// Render selector results
		this._renderIncrementalSearchResults();

		// Make sure close/dropdown button is not in the tab order
		this.refs.button.getDOMNode().tabIndex = -1;

		// if the isSelect prop is true, make the input readonly.
		if (this.props.isSelect) {
			let input = this.refs.entry.getDOMNode();
			input.readOnly = true;
		};
	},

	componentClickAway() {

		this.setState({
			focus: false,
			open: false,
			visible: [],
			selectedValue: this.state.visible.length === 1 ? this.state.visible[0] : null,
			selection: this.state.visible.length === 1 ? this.state.visible[0] : null,
			entryValue: this.state.visible.length === 1 ? this.state.visible[0].label : this.state.entryValue
		});

		React.findDOMNode(this).blur();
		this.refs.sel.setSelectionIndex(null);

		this._unbindClickAway();
	},

	componentDidUpdate() {
		// Render selector results
		this._renderIncrementalSearchResults();

		// If optionValidate prop is on, run validation whenever the component updates
		if (this.props.optionValidate && this.state.entryValue !== '') {
			this._validateEntryValue();
		};
	},

	componentWillReceiveProps(nextProps) {

		this.setState({
			visible: this.getOptionsFilter(this.state.entryValue, nextProps.options)
		});

		let hasSubtextProp = nextProps.hasOwnProperty('subtext');
		let newState = {};


		if (this.props.status !== nextProps.status) {
			newState.status = nextProps.status
		};

		if (hasSubtextProp) {
			newState.subtext = nextProps.subtext
		};

		if (newState) {
			this.setState(newState)
		};
	},

	render() {

		let {
			options,
			hintText,
			disabled,
			maxVisible,
			onOptionSelected,
			onKeyDown,
			defaultLabel,
			underlinePosition,
			selectorPosition,
			customClasses } = this.props;


		let inputClasses = ClassNames(customClasses.input);

		// Determine when to display close button via class manipulation
		let closeButtonClasses = ClassNames ({
			"lui-is-visible" : this.state.open || this.state.entryValue
		});

		// Dropdown button is always visible
		let dropDownButtonClasses = ClassNames ("lui-is-visible" , "lui-is-select");

		// Render close button, if isSelect prop is true, render dropdown button
		let button;

		if (!this.props.isSelect) {
			button = (
				<button
					ref="button"
					className={closeButtonClasses}
					type="button"
					onClick={this._onEscape} >

					<CloseIcon key="close" />

				</button>
			);
		} else {
			button = (
				<button
					onKeyDown={this._onKeyDown}
					ref="button"
					className={dropDownButtonClasses}
					type="button"
					onClick={this._onFocus} >

					<DropDownIcon key="dropdown" />

				</button>
			);
		}

		// Applying paper classes here because using paper directly creates issues with the animation.
		let selectorClasses = ClassNames('lui-paper',`lui-paper-z-depth-${this.props.depth}`,{
			"lui-is-open" : this.state.open,
			"lui-is-closed" : !this.state.open,
			"lui-is-top" : this.props.selectorPosition === 'top'
		});

		// Apply lui-is-status classes to the autoCompleteWrapper
		let autoCompleteWrapClasses = ClassNames ('lui-autocomplete-wrap', `lui-is-${this.state.status}`,{
			"lui-is-focused" : this.state.focus || this.state.status === 'error',
			"lui-is-disabled" : this.props.disabled
		});

		let bottomRounded, topRounded;

		if (this.props.selectorPosition === 'top' && this.props.rounded ) {
			topRounded = this.props.rounded && !this.state.visible.length;
			bottomRounded = true;
		} else if (this.props.selectorPosition !== 'top' && this.props.rounded) {
			topRounded = true;
			bottomRounded = this.props.rounded && !this.state.visible.length;
		}

		return (
			<div className="lui-autocomplete">
				<div>

					<TextField
						ref="entry"
						topRounded={topRounded}
						bottomRounded={bottomRounded}
						rounded={false}
						depth={this.props.depth}
						innerClassName={autoCompleteWrapClasses}
						underlinePosition={underlinePosition}
						className={inputClasses}
						value={this.state.entryValue}
						defaultValue={defaultLabel}
						onChange={this._onChange}
						onKeyDown={this._onKeyDown}
						onFocus={this._onFocus}
						hintText={this.state.hintText}
						onClick={this._onInputClick}
						floatingLabelText={this.props.floatingLabelText}
						subtext={this.props.subtext}
						subtextPush={this.props.subtextPush} />

					{button}

					<div className="lui-progress-linear" />
				</div>
				<Selector
					className={selectorClasses}
					key="selector"
					ref="sel"
					options={this.state.visible}
					onOptionSelected={this._onOptionSelected}
					customClasses={this.props.customClasses} />
			</div>
		)
	},

	getOptionsFilter(value, list, returnValue) {
		
		let options = {
			extract: function(el) { return returnValue ? el.value : el.label }
		}

		if(!value) return [];

		let result = fuzzy.filter(value, list, options).map(function(res) {
			return res.original;
		});

		if (this.props.maxVisible) {
			result = result.slice(0, this.props.maxVisible);
		}

		return result;
	},

	getValue(){
		return this.state.entryValue;
	},

	getSelected(){

		if(this.state.selectedValue){
			return this.state.selectedValue;
		} else {
			let selectedValue = {label: this.state.entryValue, value: this.state.entryValue};
			return selectedValue;
		}

	},

	setEntryText(value) {
		this.refs.entry.getDOMNode().value = value;
		this._onTextEntryUpdated();
	},

	setStatus(value) {
		this.setState({
			status: value
		});
	},

	setSubtext(value) {
		this.setState({
			subtext: value
		});
	},


	// Key Events
	eventMap(event) {
		let events = {};

		events[KeyCode.UP] = this.refs.sel.navUp;
		events[KeyCode.DOWN] = this.refs.sel.navDown;
		events[KeyCode.ENTER] = this._onEnter;
		events[KeyCode.ESC] = this._onEscape;
		events[KeyCode.TAB] = this._onTab;


		return events;
	},

	_renderIncrementalSearchResults() {

		// There are no autocomplete / autocomplete suggestions
		if (!this.state.visible.length) {
			this._closeSelector();
			return
		}

		// Nothing has been entered into the textbox
		if (this.state.entryValue === '' && !this.state.open) {
			this._closeSelector();
			return
		}

		if (this.state.open){
			this._openSelector();
			return
		}
	},

	_openSelector() {
		let element = React.findDOMNode(this.refs.sel);

		let prevheight = element.style.height;

		element.style.height = 'auto';

		let endheight = getComputedStyle(element).height;

		element.style.height = prevheight;
		element.offsetHeight; // force repaint
		element.style.transition = 'height .1s';
		element.style.height = endheight;

		element.addEventListener('webkitTransitionEnd', function transitionEnd(event) {
			if (event.propertyName == 'height') {
				element.style.webkitTransition = '';
				element.style.msTransition = '';
				element.style.mozTransition = '';
				element.style.oTransition = '';
				element.style.transition = '';
				element.style.height = 'auto';
				element.removeEventListener('webkitTransitionEnd', transitionEnd, false)
			}
		}, false);
	},

	_closeSelector() {
		let element = React.findDOMNode(this.refs.sel);

		element.style.height = getComputedStyle(element).height;
		element.style.transition = 'height .1s';
		element.offsetHeight; // force repaint
		element.style.height = '0px';
	},

	_validateEntryValue() {
		let visible = this.getOptionsFilter(this.state.entryValue, this.props.options)

		let options = this._indexOf(this.props.options);

		if(options !== -1) {
			this.refs.entry.setErrorText('');
			return;
		} else {
			this.refs.entry.setErrorText('You must select a valid option.');
			return;
		}

	},

	_indexOf(array) {
		for(let i = 0; i<array.length; i++) {
				if(array[i].label === this.state.entryValue) return i;
			}
		return -1;
	},

	_handleDropDown() {
		if (!this.state.open) {
			this.setState({
				open: true,
				focus: true,
				visible: this.props.options
			});

		} else {
			this.setState({
				open: false,
				visible: []
			});
		};
	},

	_onOptionSelected(option, event) {
		this.componentClickAway();

		let nEntry = this.refs.entry.getDOMNode();
		nEntry.focus();
		nEntry.value = option;

		this.setState({
			selection: option,
			entryValue: option.label,
			selectedValue: option
		});

		return this.props.onOptionSelected(option, event);
	},

	_onTextEntryUpdated() {
		let value = this.refs.entry.getValue();
		let visible = this.getOptionsFilter(value, this.props.options);

		if (!this.props.isSelect) {
			this.setState({
				visible: visible,
				selection: null,
				selectedValue: null,
				entryValue: value,
				open: value === '' ? false : true
			});
		}

		this.refs.sel.setSelectionIndex(null);

		if (value){
			this._renderIncrementalSearchResults();
		};
	},


	_onChange() {
		this._onTextEntryUpdated();
		this.props.onChange ? this.props.onChange() : null;

	},

	_onInputClick() {
		if (this.props.isSelect && !this.state.open) {
			this._handleDropDown();
		};
	},

	_onFocus() {
		this.setState({
			focus: true,
		});

		this._bindClickAway();
		if (this.props.isSelect && !this.state.open) {
			this._handleDropDown();
		}

	},


	// User pressed a key (down, up, esc)
	_onKeyDown(event) {

		if (!this.state.visible.length || !this.state.open) {


			switch(event.keyCode) {
				case KeyCode.DOWN:
					this.setState({
						visible: this.state.entryValue === '' ?
							this.props.options :
							this.getOptionsFilter(this.state.entryValue, this.props.options),
						open: true
					});
					break;
				case KeyCode.ESC:
					this.setState({open: false})
					break;
				case KeyCode.UP:
					break;
				default:
					// do nothing
			}

		};


		if (!this.refs.sel) {
			return this.props.onKeyDown(event);
		}

		let handler = this.eventMap()[event.keyCode];

		if (handler) {
			setTimeout(()=>{ handler(event); }, 1);
		} else {
			return this.props.onKeyDown(event);
		}

		// Don't propagate the keystroke back to the DOM/browser
		// Unless TAB is pressed
		if(event.keyCode !== KeyCode.TAB) {
			event.preventDefault();
		}

	},

	// Enter is pressed
	_onEnter(event) {
		
		if (!this.refs.sel.state.selection) {
			return this.props.onKeyDown(event);
		}

		return this._onOptionSelected(this.refs.sel.state.selection, event);
	},

	// Escape is pressed
	_onEscape(event) {
		this.refs.sel.setSelectionIndex(null);

		this.setState({
			entryValue: '',
			visible: [],
			selection: null,
			selectedValue: null,
			open: false
		});

		this.props.onDismiss();

	},

	// Tab is pressed
	_onTab(event) {

		if (this.props.isSelect) {
			this.componentClickAway();
		};

		// If there is text entered and there are >0 visible autocomplete results,
		// autocomplete result using the first child in the result array.
		if (this.state.entryValue && this.state.visible.length) {
			let option = this.refs.sel.state.selection ?
			this.refs.sel.state.selection : this.state.visible[0]

			return option ? this._onOptionSelected(option, event) : null;
		};
	}
});



/** WEBPACK FOOTER **
 ** ./src/components/autocomplete/Autocomplete.js
 **/